import SashiDo from 'lib/SashiDo';
import AccountManager from 'lib/AccountManager';
import moment from 'moment';
import history from 'dashboard/history';
import Button from 'components/Button/Button.react';
import FlowView from 'components/FlowView/FlowView.react';

import Toggle                   from 'components/Toggle/Toggle.react';
import Field                    from 'components/Field/Field.react';
import Fieldset                 from 'components/Fieldset/Fieldset.react';
import FormButton               from 'components/FormButton/FormButton.react';
import FormModal                from 'components/FormModal/FormModal.react';
import FormTable                from 'components/FormTable/FormTable.react';
import KeyField                 from 'components/KeyField/KeyField.react';
import Label                    from 'components/Label/Label.react';
import Modal                    from 'components/Modal/Modal.react';
import Parse                    from 'parse';
import React, { Component }     from 'react';
import PreLoader                from 'components/PreLoader/PreLoader.react';
import renderFlowFooterChanges  from 'lib/renderFlowFooterChanges';
import styles                   from 'dashboard/Settings/Settings.scss';
import settingsStyles           from 'dashboard/Settings/Settings.scss';
import TextInput                from 'components/TextInput/TextInput.react';
import Toolbar                  from 'components/Toolbar/Toolbar.react';
import { dateStringUTC }        from 'lib/DateUtils';
import UploadAvatarOrIcon       from 'components/UploadAvatarOrIcon/UploadAvatarOrIcon.react';
import Notification             from 'components/Notification/Notification.react';

export default class AccountInfoUpdate extends Component {
  constructor(props) {
    super();

    this.state = {
      loading: false,
      note: null,
      user: {},
    };
  }

  onClose() {
    this.setState({
      agree: false,
      showPolicies: false,
      showTos: false,
    });
  }

  onCloseClick() {
    history.push(`/account/info`);
  }

  changeAvatar(image) {
    AccountManager.changeAvatar(image);
  }

  renderForm({changes, fields, setField, resetFields}) {
    let { email, use_gravatar, image, name, createdAt } = this.props.currentUser;

    const policiesView =
      this.state.showPolicies &&
        <Modal
          width={740}
          title='SashiDo Policies'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
        >
          <div>
            <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard#privacy-policy`} />
            <div className={styles.modalCustomInfo}>
              <p>You represent and warrant that:</p>

              <ol>
                <li>You have full legal authority to agree to these terms presented above.</li>
                <li>You have read and understand these terms.</li>
                <li>You agree to these terms.</li>
              </ol>

              <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
            </div>
          </div>
        </Modal>;

    const tosView =
      this.state.showTos &&
        <Modal
          width={740}
          title='Terms of Service'
          cancelText={'Go Back'}
          onCancel={() => this.onClose()}
        >
          <div>
            <iframe className={styles.Policies} width='100%' height="100%" src={`https://www.sashido.io/en/policies/dashboard`} />
            <div className={styles.modalCustomInfo}>
              <p>You represent and warrant that:</p>

              <ol>
                <li>You have full legal authority to agree to these terms presented above.</li>
                <li>You have read and understand these terms.</li>
                <li>You agree to these terms.</li>
              </ol>

              <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
            </div>
          </div>
        </Modal>;


    let accountInfoFields =
      <Fieldset
        legend='Account Info Update'
        description='Update the personal information linked to this account.'>
        <div className={styles.settingsBox}>
          <div className={styles.infoBox} style={{ paddingBottom: 0 }}>
            <Notification note={this.state.updateSuccess} close={true} />

            <UploadAvatarOrIcon email={email} image={image} use_gravatar={use_gravatar} onChange={this.changeAvatar.bind(this)} />

            <div className={styles.info} style={{ marginTop: -20 }}>
              <Field
                label={<Label text='First Name' />}
                input={<TextInput
                  value={fields.first_name}
                  onChange={setField.bind(this, 'first_name')} />} />

              <Field
                label={<Label text='Last Name' />}
                input={<TextInput
                  value={fields.last_name}
                  onChange={setField.bind(this, 'last_name')} />} />

              <Field
                label={<Label text='Company Name' />}
                input={<TextInput
                  value={fields.company}
                  onChange={setField.bind(this, 'company')} />} />

              <Field
                label={<Label text='Phone Number' />}
                input={<TextInput
                  value={fields.phone}
                  onChange={setField.bind(this, 'phone')} />} />

              <Field
                label={<Label text='Address' />}
                input={<TextInput
                  value={fields.address}
                  onChange={setField.bind(this, 'address')} />} />

              <Field
                label={<Label text='Twitter Account' />}
                input={<TextInput
                  value={fields.cf_twitter}
                  placeholder='Your Twitter username'
                  onChange={setField.bind(this, 'cf_twitter')} />} />

              <Field
                label={<Label text='Facebook Account' />}
                input={<TextInput
                  value={fields.cf_facebook}
                  placeholder='Your Facebook username'
                  onChange={setField.bind(this, 'cf_facebook')} />} />


            </div>

          </div>
          <div className={styles.hr} />

          <div className={[styles.agree].join(' ')}>
            <Toggle
              value={fields.agreeReceiveNewsletter}
              onChange={setField.bind(this, 'agreeReceiveNewsletter')}
              />

              <p>I agree to receive newsletters on my e-mail in accordance with SashiDo's<br /> <a href="javascript:;" onClick={() => this.setState({ showTos: true })}>Terms of Use</a> and <a href="javascript:;" onClick={() => this.setState({ showPolicies: true })}>Privacy Notice</a>.</p>
          </div>
        </div>
      </Fieldset>

    let classes = [settingsStyles.settings_page, settingsStyles.default];

    return(
      <div className={classes.join(' ')}>
        <Toolbar section={this.props.section} subsection={'Update Your Info'}>
          <Button value='Go Back' onClick={this.onCloseClick} />
        </Toolbar>
        <div className={[settingsStyles.holder, 'ShowFooter'].join(' ')}>
          <PreLoader loading={this.state.loading}>
            {accountInfoFields}
            {policiesView}
            {tosView}
          </PreLoader>
        </div>
      </div>
    );
  }

  render() {
    let { first_name, last_name, company, phone, cf_twitter, cf_facebook, } = this.props.currentCustomer.info;

    let initialFields = {
      first_name: first_name || '',
      last_name : last_name || '',
      company: company || '',
      phone: phone || '',
      cf_twitter: cf_twitter ? cf_twitter.replace('https://twitter.com/', '') : '',
      cf_facebook: cf_facebook ? cf_facebook.replace('https://facebook.com/', '') : '',
      agreeReceiveNewsletter: this.props.currentUser.agreeReceiveNewsletter || false,
    };

    return <FlowView
      initialFields={initialFields}
      footerContents={({ changes }) => renderFlowFooterChanges(changes, initialFields, pushFieldOptions)}
      onSubmit={({ changes, setField, resetFields }) => {
        const { first_name, last_name, company, phone, address, cf_twitter, cf_facebook, agreeReceiveNewsletter } = changes;

        const obj = {
          customer_id: this.props.currentCustomer.info.id,
        };

        Object.keys(changes).forEach((key) => {
          if(key === 'cf_twitter') {
            obj[key] = `https://twitter.com/${changes[key]}`
          } else if(key === 'cf_facebook') {
            obj[key] = `https://facebook.com/${changes[key]}`
          } else {
            obj[key] = changes[key]
          }
        })

        return new Promise((resolve, reject) => {
          return SashiDo.changeUserInfo(obj).then((data) =>{
            if(data.error_message) {
              return reject({ error: data.error_message })
            }

            this.setState({ successMessage: { type: 'info', message: 'Your account info was successfully updated!' } });
            AccountManager.init(true);
            return resolve();
          });
        });
      }}

      validate={({ changes }) => {

      }}
      renderForm={this.renderForm.bind(this)} />;
  }
}

let pushFieldOptions = {
  first_name: {
    friendlyName: 'First name',
    type: 'addition',
  },
  last_name: {
    friendlyName: 'Last name',
    type: 'addition',
  },
  company: {
    friendlyName: 'Company name',
    type: 'addition',
  },
  phone: {
    friendlyName: 'Phone number',
    type: 'addition',
  },
  cf_twitter: {
    friendlyName: 'Twitter account',
    type: 'addition',
  },
  cf_facebook: {
    friendlyName: 'Facebook account',
    type: 'addition',
  },
  agreeReceiveNewsletter: {
    friendlyName: 'Receiving newsletter',
    type: 'boolean',
  },
}
